// Grid of document listing cards for canonical collection pages.

import React from 'react';
import {
  getReportGradientAccentFamily,
  type Document,
} from '@airhead-games/shared/content';
import DocumentListingCard from '@/content/rendering/documentListings/DocumentListingCard';

interface DocumentListingGridProps {
  documents: Document[];
  featuredFirst?: boolean;
  variant?: 'default' | 'report-month';
}

const DocumentListingGrid: React.FC<DocumentListingGridProps> = ({
  documents,
  featuredFirst,
  variant = 'default',
}) => {
  if (documents.length === 0) {
    return (
      <p className="text-sm leading-6 text-muted-foreground">
        No documents found.
      </p>
    );
  }

  const [featuredDocument, ...remainingDocuments] = documents;

  return (
    <div className="flex flex-col gap-6">
      {featuredFirst && featuredDocument && (
        <DocumentListingCard
          document={featuredDocument}
          featured
          variant={variant}
          accentFamily={
            variant === 'report-month'
              ? getReportGradientAccentFamily(
                  featuredDocument.meta?.reportMonth
                )
              : undefined
          }
        />
      )}
      <div
        className={
          variant === 'report-month'
            ? 'grid w-full max-w-6xl grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3 xl:grid-cols-4'
            : 'grid gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
        }
      >
        {(featuredFirst ? remainingDocuments : documents).map((document) => (
          <DocumentListingCard
            key={document.id}
            document={document}
            variant={variant}
            accentFamily={
              variant === 'report-month'
                ? getReportGradientAccentFamily(document.meta?.reportMonth)
                : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};

export default DocumentListingGrid;
